<template>
  <div
      class="i-header"
      :class="[{ fixedToTop }, themeColor, { iHeader: isProductHover }]"
  >
    <div>
      <div class="header">
        <div class="logo">
          <router-link :to="{ path: '/' }">
            <a class="logo1">
              <logo :isTransparent="themeColor === 'is-transparent'"></logo>
            </a>
            <a class="logo2">
              <logo :isTransparent="themeColor === 'main-color'"></logo>
            </a>
          </router-link>
        </div>
        <ul class="navbar navHover">
          <div v-for="item in tabs" :key="item.id">
            <router-link
                v-if="item.name === $t('main.home') && item.is_menu == 1"
                :to="{ path: getRoutesPath(item['list_template'], item['identification'], item['id']) }"
                custom
                v-slot="{ href, navigate }"
            >
              <li
                  class="navbar-item"
                  :class="{ 'active': $route.path === templates[item['list_template']] }"
                  @mouseover="(isProductHover = true), (isProduct = item.name === $t('main.productCenter'))"
              >
                <a
                    :href="href"
                    class="super-link center"
                    @click="navigate"
                >
                  {{ item.name }}
                </a>
              </li>
            </router-link>
            <router-link
                v-else
                :to="{ path: getRoutesPath(item['list_template'], item.identification, item.id) }"
                custom
                v-slot="{ href, navigate }"
            >
              <li
                  class="navbar-item"
                  :class="{ 'active': $route.path.indexOf(templates[item['list_template']]) > -1 }"
                  @mouseover="(isProductHover = true), (isProduct = item.name === $t('main.productCenter'))"
              >
                <a
                    :href="href"
                    class="super-link center"
                    @click="navigate"
                >
                  {{ item.name }}
                </a>
              </li>
            </router-link>
          </div>
        </ul>
        <div class="fac user-box">
          <div class="fac search-user-box">
            <div class="fac search">
              <div class="search-input">
                <el-input
                    type="text"
                    v-model="search"
                    :placeholder="$t('main.pleaseEnter')"
                    class="searchInput"
                    @keyup.enter.native="enterkey"
                ></el-input>
              </div>
              <div class="search-icon">
                <i @click="enterkey" class="el-icon-search"></i>
              </div>
            </div>
            <div
                class="user"
                @mouseover="(isProductHover = false), (isProduct = false)"
            >
              <div class="login" v-if="!isLogin">
                <span class="login__text" @click="goToLogin"> {{ $t('main.login') }}</span>
                /
                <span class="login__text" @click="goToRegister">{{ $t('main.register') }}</span>
              </div>

              <div class="dropdown-menu" v-else>
              <span class="dropdown-menu__email">
                <span class="user-name">{{ username }}</span>
                <i class="arrow"></i>
              </span>
                <ul class="dropdown-menu__wrapper">
                  <router-link
                      to="/userCenter"
                  >
                    <li
                        class="dropdown-menu__item"
                    >
                      {{ $t("main.personCenter") }}
                    </li>
                  </router-link>
                  <li class="dropdown-menu__item" @click="handleLogout">
                    {{ $t("main.logout") }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="change-site">
            <div class="dropdown-menu">
              <span class="dropdown-menu__site">
                <span class="site-name">{{ langLanguageText() }}</span>
                <i class="arrow"></i>
              </span>
              <ul class="dropdown-menu__wrapper">
                <li
                    v-for="item in sites"
                    :key="item.id"
                    class="dropdown-menu__item"
                    :class="{'active': item.id == langLanguage }"
                    @click="handleChangeSite(item.id)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
      <div class="isIn">
        <div class="fac" v-if="!isProduct">
          <div class="logo"></div>
          <div
              class="navbar"
              style="height: 100%;"
              @mouseover="isProductHover = true"
          >
            <div class="navbar-item" v-for="item in tabs" v-if="item.is_menu == 1" :key="item.id">
              <div v-for="v in item.child" :key="v.id">
                <div
                    v-if="item.name === $t('main.productCenter')"
                    @click="goLink(v)"
                >
                  <li class="navTitle" role="link">
                    <a>{{ v.name }}</a>
                  </li>
                </div>
                <div
                    v-if="item.name !== $t('main.productCenter') && v.is_menu == 1"
                    @click="goLink(v)"
                >
                  <li class="navTitle" role="link">
                    <a>{{ v.name }}</a>
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 25%;"></div>
        </div>
        <div v-else class="isProduct">
          <div
              class="fac mb12"
              v-for="item in productList"
              :key="item.id"
              @click="goLink(item)"
          >
            <div class="pTitle">{{ item.name }}</div>
            <div class="pContent fac">
              <div class="pItem" v-for="(it, inx) in item.child" :key="inx"
                   @click.stop="goLink(it)"
              >
                <img v-if="it.image" :src="it.image" class="cImg" />
                <div v-else class="cImg img_replace"> {{ $t('main.nopic') }}</div>
                <div class="ptext">{{ it.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!cookieEnable" class="cookie">
      {{ $t("main.PleaseEnableBrowserCookies") }}
    </div>
  </div>
</template>
<script>
// import store from "@/store";
import {
  getSites,
  getSiteInfoById,
  getTabs,
  setSites,
  getProductNav
} from "@/api";
import Cookies from "js-cookie";
import axios from "axios";
import i18n from "@/lang";

export default {
  name: "Header",
  data() {
    return {
      cookieEnable:true,
      state: this.$store.state,
      isCN: true,
      dLogo: true,
      isChoose1: false,
      search: "",
      isProductHover: false,
      isProduct: false,
      isLogin: false, // 判断是否登录
      username: "",
      productList: [],
      sites: [],
      langLanguage: null,
      tabs: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  created() {
    if ((this.$store.state.userInfo && this.$store.state.userInfo.username) || Cookies.get("userinfo")) {
      this.isLogin = true;
      const userInfo = JSON.parse(Cookies.get("userinfo")) || this.$store.state.userInfo;
      if(this.$i18n.locale === 'zn') {
        this.username = userInfo.nickname || userInfo.telephone;
      } else {
        this.username = userInfo.nickname || userInfo.email;
      }
    } else {
      this.isLogin = false;
    }

    if (Cookies.get("siteInfo")) {
      this.langLanguage = parseInt(Cookies.get("siteInfo"));
    }
    this.getAllsites();
  },
  props: {
    fixedToTop: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: "main-color"
    }
  },
  watch: {
    "$store.state.userInfo": function(newV) {
      if (newV) {
        if ((this.$store.state.userInfo && this.$store.state.userInfo.username) || Cookies.get("userinfo")) {
          this.isLogin = true;
          const userInfo = JSON.parse(Cookies.get("userinfo")) || this.$store.state.userInfo;
          if(this.$i18n.locale === 'zn') {
            this.username = userInfo.nickname? userInfo.nickname:userInfo.telephone;
          } else {
            this.username = userInfo.nickname? userInfo.nickname:userInfo.email;
          }
        } else {
          this.isLogin = false;
        }
      }
    },
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.langLanguage = newV;
        this.handleChangeSite(newV);
        if ((this.$store.state.userInfo && this.$store.state.userInfo.username) || Cookies.get("userinfo")) {
          this.isLogin = true;
          const userInfo = JSON.parse(Cookies.get("userinfo")) || this.$store.state.userInfo;
          if(this.$i18n.locale === 'zn') {
            this.username = userInfo.nickname? userInfo.nickname:userInfo.telephone;
          } else {
            this.username = userInfo.nickname? userInfo.nickname:userInfo.email;
          }
        }
      }
    },
    "$route.query.keyword":function (newV) {
      this.search = newV;
    }
  },
  methods: {
    async checkLocation() {
      try {
        // 获取IP地址（使用ipify作为示例）
        const ipResponse = await axios.get('https://ipinfo.io/json');
        const countryCode = ipResponse.data.country; // 国家代码，例如CN表示中国

        // 判断是否在中国
        if (countryCode === 'CN') {
          this.langLanguage = 1;
          this.handleChangeSite(this.langLanguage);
        } else {
          this.langLanguage = 2;
          this.handleChangeSite(this.langLanguage);
        }
      } catch (error) {
        this.langLanguage = 2;
        this.handleChangeSite(this.langLanguage);
      }
    },
    langLanguageText() {
      let nowLangLanguage = this.sites.find(item => (
          item.id == this.langLanguage
      ));
      return nowLangLanguage ? nowLangLanguage.name : '';
    },
    enterkey() {
      this.$router.push({
        path: "/searchResult",
        query: { keyword: this.search }
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    goLink(item) {
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
    getAllsites() {
      let params = {
        req: {
          page: 1,
          where: [
            {
              condition: "1",
              filed: "status",
              expression: "="
            }
          ],
          limit: 1000,
          order: "id asc"
        }
      };
      getSites(params).then(res => {
        if (res.rsp.code === 0) {
          this.sites = res.data.list;
          if (!Cookies.get("siteInfo")) {
            // 判断当前IP是国内还是国外
            this.checkLocation();
          } else {
            this.handleChangeSite(this.langLanguage);
          }
        }
      });
    },
    getAllTabs() {
      this.handlegetProductNav();
      if (!Cookies.get("hasNavTabs_" + Cookies.get("siteInfo")) || !localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let params = {
          req: {
            pid: 0,
            site_id: Cookies.get("siteInfo"),
            status: 1
          }
        };
        getTabs(params).then(res => {
          if (res.rsp.code === 0) {
            // 处理导航数据
            let tab = [];
            let tabsstatic = [
              {
                id: "index",
                model_id: "0",
                is_menu: 1,
                is_post: 0,
                name: this.$t("main.home"),
                identification:"",
                list_template: "index",
                article_template: "",
                child: []
              },
              {
                id: "productCenter",
                model_id: "0",
                is_menu: 1,
                is_post: 0,
                name: this.$t("main.productCenter"),
                identification:"",
                list_template: "category_product",
                article_template: "detail_product",
                child: this.productList
              }
            ];

            if (res.data.tree) {
              tab = tabsstatic.concat(this.arrayToTree(res.data.tree));
              this.tabs = tab;
              // 存储在本地
              localStorage.setItem("navTabs_" + Cookies.get("siteInfo"), JSON.stringify(tab));
              Cookies.set("hasNavTabs_" + Cookies.get("siteInfo"), true);
              this.$store.dispatch("setTabs", Cookies.get("siteInfo"));
            }
          }
        });
      } else {
        this.tabs = JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo")));
      }
    },
    handlegetProductNav() {
      if (!Cookies.get("hasProductType_" + Cookies.get("siteInfo")) || !localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        let params = {
          req: {
            pid: 0,
            site_id: Cookies.get("siteInfo"),
            status: 1
          }
        };
        getProductNav(params).then(res => {
          if (res.rsp.code === 0) {
            this.productList = res.data.tree ? this.arrayToTree(res.data.tree) : [];
            localStorage.setItem("productTypeNav_" + Cookies.get("siteInfo"), JSON.stringify(this.productList));
            Cookies.set("hasProductType_" + Cookies.get("siteInfo"), true);
          }
        });
      } else {
        this.productList = JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo")));
      }
    },
    // 中英文切换
    handleChangeSite(val) {
      getSiteInfoById({ req: { id: val } }).then(res => {
        if (res.rsp.code === 0) {
          if (res.data.lang == "zh-cn") {
            this.$i18n.locale = "zn";
          } else {
            this.$i18n.locale = "en";
          }
          this.changeDocumentInfo(res.data);
          Cookies.set("siteInfo", val);
          this.uploadSiteInfo(val)
          // 在Vue组件中调用mutations中的方法
          this.$store.dispatch('setSiteInfo', val)
          this.$emit("changeSite", res.data);
          this.getAllTabs();
        }
      });
    },
    // 切换站点上传
    uploadSiteInfo(val) {
      setSites({req: {
          site_id: val
        }})
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    // 一维数组转树
    arrayToTree(arr) {
      let res = [];
      let obj = {};
      arr = this.treeToArray(arr);
      arr.forEach(item => {
        item.id = item.id.toString();
        obj[item.id] = {
          ...item,
          child:[]
        };
      });
      arr.forEach(item => {
        item.id = item.id.toString();
        if (obj[item.pid]) {
          obj[item.pid].child.push(obj[item.id]);
        } else {
          res.push(obj[item.id]);
        }
      });
      return res;
    },
    changeDocumentInfo(data) {
      document.title = data.meta_title;
      let meta = document.querySelector("link[name*='description']") || document.createElement("meta");
      meta.name = "description";
      meta.content = data.meta_description;
      // meta.content = window.sessionStorage.getItem("meta_description");
      document.getElementsByTagName("head")[0].appendChild(meta);
      // Keywords
      let meta2 = document.querySelector("link[name*='keywords']") || document.createElement("meta");
      meta2.name = "keywords";
      meta2.content = data.meta_keywords;
      // meta2.content = window.sessionStorage.getItem("meta_keywords");
      document.getElementsByTagName("head")[0].appendChild(meta2);
    },
    goToLogin() {
      this.$router.push("/login");
    },
    goToRegister() {
      this.$router.push("/register");
    },
    handleLogout() {
      // 弹层询问，是否退出
      this.$confirm(this.$t('main.confirmOperate'), this.$t('main.tip'), {
        confirmButtonText: this.$t('main.sure'),
        cancelButtonText: this.$t('main.cancel'),
        type: "warning"
      }).then(() => {
        this.$store.dispatch("setUserinfo", {});
        Cookies.remove("userinfo");
        this.login = false;
        this.username = "";
        this.$router.push(`/login`);
      }).catch(() => {
        // 用户取消退出
      });
    }
  }
};
</script>

<style lang="less" scoped>
.i-header {
  color: #1a1a1a;

  &.fixedToTop {
    position: absolute;
    width: 100%;
  }

  &.main-color {
    background-color: #f2f2f2;

    .navbar-item {
      &:hover {
        color: #808080;
      }
    }

    .login-text {
      color: #808080;
    }

    .super-link {
      color: #1a1a1a;
    }

    &:hover {
      .logo1 {
        display: block;
      }

      .logo2 {
        display: none;
      }
    }
  }

  &.is-transparent {
    color: #fff;
    background-color: rgba(0,0,0,0.3);

    .navbar-item {
      &:hover {
        color: #808080;
      }
    }

    .active {
      color: #fff;
    }
  }
}

.cookie {
  height: 400px;
  line-height: 400px;
  text-align: center;
  font-size: 1.875rem;
  width: 100%;
  position: absolute;
  background: #635796;
  z-index: -1;
  top: 0;
}

.header {
  display: flex;
  height: 60px;
  line-height: 60px;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  width: 130px;

  a {
    height: 100%;
  }
}

.navbar {
  margin-left: 28px;
  min-width: 160px;
  display: flex;

  &-item {
    width: 100px;
    text-align: center;

    &.active a {
      border-bottom: 2px solid;
      color: #fff;
      text-decoration: none;
    }
  }
}
.user-box {
  width: 300px;
  position: absolute;
  justify-content: space-between;
}
.search-user-box {
  width: 200px;
  height: 60px;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
}

.super-link {
  position: relative;
  text-decoration: none;
  color: #fff;
  font-size: 1.1428rem;
  padding: 10px 0px;

  &.active {
    border-bottom: 2px solid;
    color: #fff;
  }
}

/*伪元素是两个冒号*/
.super-link::after {
  content: "";
  width: 30px;
  height: 2px; /*设置伪元素的高度，这里是下划线的粗细*/
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: auto;
  background-color: currentColor; /*当前标签继承的文字颜色，这里让伪元素的背景色与父元素的文字颜色相同*/
  transform: scale(0);
  transition: all 0.65s;
}

.super-link:hover::after {
  transform: scale(1);
}

.center::after {
  transform-origin: center;
}
.change-site {
  width: 80px;
  height: 60px;
  line-height: 60px;
  text-align: center;

  .arrow {
    display: inline-block;
    border: 1px solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
    transform-origin: center;
    vertical-align: 3px;
    margin-left: 4px;
    transition: all 0.3s;
    width: 8px;
    height: 8px;
  }

  &:hover {
    .arrow {
      transform: rotate(-45deg);
      vertical-align: -3px;
    }

    .dropdown-menu__wrapper {
      min-width: 105px;
      width: auto;
      display: block;
    }
  }

  .dropdown-menu {
    position: relative;
    z-index: 1000;

    .site-name {
      overflow: hidden;
      min-width:25px;
      max-width: 65px;
      display: -webkit-inline-flex;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__site {
      line-height: 18px;
      cursor: pointer;
    }

    &__wrapper {
      position: absolute;
      display: none;
      right: 0;
      color: @regular-text-color;
      padding: 8.75px 0;
      width: 105px;
      border-radius: 5px;
      box-shadow: 0 0px 2px 1px #eee;
      background: #fff;
      text-align: center;

      .active {
        color: #635796 !important;
      }
    }

    &__item {
      padding: 0 1.5rem;
      line-height: 30px;
      cursor: pointer;
      color: #999;

      &:hover {
        background: #efefef58;
      }
    }
  }

}

.user {
  width: 220px;
  height: 25px;
  line-height: 25px;
  font-size: 0.9rem;
  text-align: center;

  .arrow {
    display: inline-block;
    border: 1px solid;
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
    transform-origin: center;
    vertical-align: 3px;
    margin-left: 4px;
    transition: all 0.3s;
    width: 8px;
    height: 8px;
  }

  &:hover {
    .arrow {
      transform: rotate(-45deg);
      vertical-align: -3px;
    }

    .dropdown-menu__wrapper {
      min-width: 105px;
      width: auto;
      display: block;
    }
  }

  .dropdown-menu {
    position: relative;
    z-index: 1000;

    .user-name {
      min-width: 90px;
      max-width: 160px;
      overflow: hidden;
      display: -webkit-inline-flex;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__email {
      line-height: 18px;
      cursor: pointer;
    }

    &__wrapper {
      position: absolute;
      display: none;
      right: 0;
      color: @regular-text-color;
      padding: 8.75px 0;
      width: 105px;
      border-radius: 5px;
      box-shadow: 0 0px 2px 1px #eee;
      background: #fff;
      text-align: center;
    }

    &__item {
      padding: 0 1.5rem;
      cursor: pointer;
      color: #999;

      &:hover {
        background: #efefef58;
      }
    }
  }
}

.lang {
  margin-left: 15px;

  .langSpan {
    color: #bababa;
    font-weight: bold;
    cursor: pointer;
  }
}

.active {
  color: #1a1a1a !important;
  font-weight: bold !important;
}

.search {
  width: 200px;
  height: 24px;
  line-height: 24px;
  text-align: end;
}

.search-input {
  width: 200px;
  height: 24px;
}

.el-icon-search {
  cursor: pointer;
  position: relative;
  right: 1.5rem;
  z-index: 99999;
}

.iHeader:hover {
  background: #ccc;
  color: #1a1a1a;

  .isIn {
    display: block;
  }

  .logo1 {
    display: none;
  }

  .logo2 {
    display: block;
  }

  .super-link {
    color: #1a1a1a;
  }

  .active {
    color: #1a1a1a;
  }
}
@media screen and (max-width: 1400px) {
  .header,
  .isIn {
    padding: 0 2%;
  }
  .user-box {
    right: 2%;
  }
}
@media screen and (min-width: 1400px) {
  .header,
  .isIn {
    padding: 0 10%;
  }
  .user-box {
    right: 10%;
  }
}
@media screen and (min-width: 1700px) {
  .header,
  .isIn {
    padding: 0 15%;
  }
  .user-box {
    right: 15%;
  }
}

.logo1 {
  display: block;
}

.logo2 {
  display: none;
}

.isIn {
  background-color: #fff;
  min-height: 455px;
  color: #d9d9d9;
  display: none;
  width: 100%;
  position: absolute;
  z-index: 1;
}

@keyframes subnavmove {
  0% {
    transform: scale(1);
    opacity: 0;
  }
  60% {
    transform: scale(1.01);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.isProduct {
  color: #d9d9d9;
  padding: 0.875rem 0;
  min-width: 875px;
  .pTitle {
    width: 100px;
    font-weight: 400;
    color: #808080;
    cursor: pointer;
  }

  .pTitle:hover {
    color: #333;
    font-weight: bold;
  }

  .pContent {
    width: calc(100% - 100px);
  }

  .pItem {
    text-align: center;
    cursor: pointer;
    .cImg {
      height: 56px;
      border-radius: 1rem;
    }

    .img_replace {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #666666;
    }

    .ptext {
      color: #666666;
    }
  }

  .mb12 {
    margin-bottom: 12px;
  }

  .pItem + .pItem {
    margin-left: 4%;
  }
}

.navTitle {
  margin-top: 2rem;
  cursor: pointer;
  &:hover {
    color: #333;
    font-weight: bold;
  }
}

.login__text {
  cursor: pointer;
}

.mWidth {
  width: calc(100% - 12.5rem);
}

/deep/ .el-input {
  font-size: inherit;
}
/deep/ .el-input__inner {
  height: 24px;
  border: 1px solid rgba(#333333, 0.4);
  border-radius: 12px;
  font-size: 0.9rem;
  text-align: center;
  background-color: transparent;
  color: #1a1a1a;
}

/deep/ .el-input__icon {
  height: 24px;
  line-height: 24px;
}

/deep/ .el-input__suffix {
  color: #1a1a1a;
}

/deep/ .el-input__inner::placeholder {
  color: #999;
}
</style>
